import { useNavigate, useLocation, useNavigationType } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export const useNavigateWithScrollMemory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationType = useNavigationType();
  const isBackNavigation = useRef(false);

  const navigateWithScrollMemory = (to, options) => {
    // 현재 위치와 스크롤 Y 값을 저장
    sessionStorage.setItem(`scroll-position:${location.pathname}`, window.scrollY);
    navigate(to, options);
  };

  useEffect(() => {
    // navigationType이 'POP'이면 뒤로가기/앞으로가기
    if (navigationType === 'POP') {
      isBackNavigation.current = true;
    }
  }, [navigationType]);

  useEffect(() => {
    // 뒤로가기로 인한 네비게이션인 경우에만 스크롤 위치 복원
    if (isBackNavigation.current) {
      const savedY = sessionStorage.getItem(`scroll-position:${location.pathname}`);
      if (savedY !== null) {
        // DOM이 완전히 렌더링된 후 스크롤 복원
        setTimeout(() => {
          window.scrollTo({
            top: parseInt(savedY, 10),
            behavior: 'auto',
          });
          sessionStorage.removeItem(`scroll-position:${location.pathname}`);
        }, 100);
      }
      // 뒤로가기 플래그 리셋
      isBackNavigation.current = false;
    }
  }, [location.pathname]);

  return navigateWithScrollMemory;
};
